export const table = {
	defaultCategoryName: "Products",
	exportExcel: "Export Excel",
	productCount: {
		singular: "product",
		plural: "products",
	},
	loading: {
		categories: "Loading categories",
		products: "Loading Products",
	},
	dropdown: {
		editCategory: "Edit category",
		deleteCategory: "Delete category",
		categoryButton: "Category",
	},
	columns: {
		bars: "Bars",
		barsTooltip: "Click to view bars",
		barsLabel: "Bars",
		mountableTooltip: "Click to view mountable product",
		productionRuleTooltip: "Click to view production rule",
		active: "Status",
		mountableDescription: "Mountable",
		fiscalCode: "SKU",
		name: "Product",
		hasProductionRule: "Datasheet",
		fiscalData: "Tax Data",
		value: "Price",
		actions: "Actions",
	},
	fiscalStatus: {
		testedTooltip: "Fiscal data registered and validated",
		errorTooltip: "We found errors in the fiscal data presented",
		notTestedTooltip: "Fiscal data registered. Awaiting test.",
	},
	variablePrice: "Variable",
	validation: {
		pricePositive: "Price must be a positive value",
		maxValue: "Price must not exceed the maximum allowed value (21,474,836.47)",
	},
	priceUpdateSuccess: "The price of {{productName}} has been updated successfully.",
	priceChangeModal: {
		title: "Change product price",
		description:
			"You are changing the price of product <strong>{{productName}}</strong> to <strong>{{price}}</strong>.",
		secondParagraph:
			"Before leaving the price edit, confirm whether you want to continue with the change or cancel.",
		cancelButton: "Cancel",
		confirmButton: "Change price",
	},
	priceChangeInvalidModal: {
		title: "Invalid value",
		description:
			"The entered value is not valid. The previous product price will be kept.",
		cancelButton: "Cancel",
	},
	priceUpdateCancelledNotification: {
		title: "Could not update price",
		description: "We kept the last price on the product",
	},
	priceUpdateSuccessNotification: {
		title: "Price updated successfully!",
		description: "{{productName}} has been updated to {{price}}",
	},
	notifications: {
		copyImageSuccess: {
			title: "Success!",
			description: "Image hash copied to clipboard",
		},
	},
	emptyState: {
		categoryWithoutProducts: "Category without products",
		noProductsFound: "No products found",
		noProductsCreated: "No product created",
		noProductsCreatedMessage:
			"Create your first product and link it to a category to appear here",
		addProducts: "Add products and link to this category.",
		addProductButton: "Add product",
		noSearchResults: "We didn't find products that match your search for",
		clearSearchButton: "Clear search",
		clearFiltersButton: "Clear filters",
		andToAppliedFilters: "and to applied filters",
		noProductsMatchingFilters: "We didn't find products that match the applied filters",
	},
};
